import { render, staticRenderFns } from "./NotesComponent.vue?vue&type=template&id=9f41d47e&scoped=true&"
import script from "./NotesComponent.vue?vue&type=script&lang=js&"
export * from "./NotesComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotesComponent.vue?vue&type=style&index=0&id=9f41d47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f41d47e",
  null
  
)

export default component.exports